module.exports = __webpack_public_path__ + "img/JanChristopherKölln_140x140_rund.1be25a7a.jpg";